<template>
  <el-dialog
    v-el-drag-dialog
    :title="$t('SeaExport.Charge') + $t('SeaExport.Details')"
    :visible.sync="innerVisible"
    width="1200px"
    append-to-body
    :close-on-click-modal="false"
    class="app-main-inner"
    @close="cancel"
  >
    <div>
      <cargo-ag-grid
        config-module="2023040701"
        :grid-options="gridOptions"
        :grid-params.sync="gridParams"
        :column-defs="columnDefs"
        :row-data="rowData"
        style="width:100%;min-height:400px"
        @gridReady="params=>gridApi=params.api"
      />
    </div>
  </el-dialog>
</template>
<script>

import { queryRelevanceChargeFunc } from '@/api/financeManage/accountingDocument'
import ColumnUtils from '@/utils/ColumnUtils'
import { TYPE_NAMES } from '@/utils/class/AdvanceSelect'
import CustomLabelUtils from '@/utils/CustomLabelUtils'

export default {
  name: 'AccountEntryChargeDetailWindow',
  components: {},
  props: {
    visible: { type: Boolean, required: true }
  },
  data() {
    return {
      gridParams: {},
      gridOptions: {
        rowSelection: 'multiple',
        suppressCellSelection: true,
        context: {
          componentParent: this
        }
      },
      innerVisible: false,
      columnDefs: [
        { headerName: this.$t('Invoice.invoice_businessNumber'), field: 'jobNo',
          cellRendererFramework: 'agGridColumnEdit',
          custom: {
            tag: 'router-and-print',
            attrs: {
              useRoute: true,
              usePrint: false,
              routeName: 'FinanceManage',
              routeParamKeys: { jobNo: 'jobNo' },
              routeTitle: this.$t('Payment.financialAudit'),
              routePermissions: ['module_ACVerify'],
              extraRouteParams: {}
            }
          }, onCellClicked: (params) => {
            if (params.event.target.tagName === 'A') {
              this.cancel(true)
            }
          },
          width: 150 },
        {
          headerName: this.$t('CargoMsg.Cargo_ChargeName'),
          headerClass: 'ag-header-cell-left',
          cellStyle: {
            textAlign: 'left'
          },
          colId: 'chargeItemId',
          field: 'chargeItemId',
          initialWidth: 180,
          valueFormatter: (params) => {
            return ColumnUtils.resolveColumnLabel(TYPE_NAMES.basic_data_ChargeItem, 'itemId', params.value, 'zhName')
          },
          editable: false
        },
        {
          headerName: this.$t('CargoMsg.Cargo_SettleAccountsTo'),
          headerClass: 'ag-header-cell-left',
          cellStyle: {
            textAlign: 'left'
          },
          colId: 'accountId',
          field: 'accountId',
          initialWidth: 180,
          valueFormatter: (params) => {
            return CustomLabelUtils.getLabel(TYPE_NAMES.basic_data_Company, 'cmpIdx', params.value, 'auto_0')
          },
          editable: false
        },
        {
          headerName: this.$t('CargoMsg.Cargo_Currency'), colId: 'currency', field: 'currency', initialWidth: 180,
          headerClass: 'ag-header-cell-center',
          cellStyle: {
            textAlign: 'center'
          },
          editable: false
        },
        {
          headerName: this.$t('CargoMsg.Cargo_UnitPrice'), colId: 'unitRate', field: 'unitRate', initialWidth: 180,
          headerClass: 'ag-header-cell-right',
          cellStyle: {
            textAlign: 'right'
          },
          valueFormatter: (params) => {
            return this.$numeral(params.value).format('0.000')
          },
          editable: false
        },
        {
          headerName: this.$t('CargoMsg.Cargo_AmountNumber'), colId: 'quantity', field: 'quantity', initialWidth: 180,
          headerClass: 'ag-header-cell-right',
          cellStyle: {
            textAlign: 'right'
          },
          valueFormatter: (params) => {
            return this.$numeral(params.value).format('0.000')
          },
          editable: false
        },
        {
          headerName: this.$t('CargoMsg.Cargo_Unit'), colId: 'measure', field: 'measure', initialWidth: 180,
          headerClass: 'ag-header-cell-left',
          cellStyle: {
            textAlign: 'left'
          },
          valueFormatter: (params) => {
            return ColumnUtils.resolveColumnLabel(TYPE_NAMES.basic_data_ChargeUnit, 'code', params.value, 'chineseName')
          },
          editable: false
        },
        {
          headerName: this.$t('CargoMsg.Cargo_ExchangeRate2'),
          headerClass: 'ag-header-cell-left',
          cellStyle: {
            textAlign: 'left'
          },
          colId: 'exchangeRate',
          field: 'exchangeRate',
          initialWidth: 180,
          valueFormatter: (params) => {
            return this.$numeral(params.value).format('0.000000')
          },
          editable: false
        },
        {
          headerName: this.$t('CargoMsg.Cargo_InvoiceNo'),
          headerClass: 'ag-header-cell-left',
          cellStyle: {
            textAlign: 'left'
          },
          colId: 'invoiceNo',
          field: 'invoiceNo',
          initialWidth: 180,
          editable: false
        },
        {
          headerName: this.$t('CargoMsg.Cargo_Domestic') + this.$t('CargoMsg.Cargo_International'),
          headerClass: 'ag-header-cell-center',
          cellStyle: {
            textAlign: 'center'
          },
          colId: 'oversea',
          field: 'oversea',
          initialWidth: 180,
          valueFormatter: (params) => {
            return params.value ? this.$t('SeaExport.overseas') : this.$t('SeaExport.internal')
          },
          editable: false
        },
        {
          headerName: this.$t('CargoMsg.Cargo_RevenueAndExpenditureType'),
          headerClass: 'ag-header-cell-center',
          cellStyle: {
            textAlign: 'center'
          },
          colId: 'receivable',
          field: 'receivable',
          initialWidth: 180,
          valueFormatter: (params) => {
            return params.value ? this.$t('CargoMsg.Cargo_Receivable') : this.$t('CargoMsg.Cargo_Dues')
          },
          editable: false
        },
        {
          headerName: this.$t('CargoMsg.Cargo_TaxIncludedPrice'), colId: 'amount', field: 'amount', initialWidth: 180,
          headerClass: 'ag-header-cell-right',
          cellStyle: {
            textAlign: 'right'
          },
          valueFormatter: (params) => {
            return this.$numeral(params.value).format('0.00')
          },
          editable: false
        },
        {
          headerName: this.$t('CargoMsg.Cargo_TaxExcludedPrice'),
          headerClass: 'ag-header-cell-right',
          cellStyle: {
            textAlign: 'right'
          },
          colId: 'excludingTaxAmount',
          field: 'excludingTaxAmount',
          initialWidth: 180,
          valueFormatter: (params) => {
            return this.$numeral(params.value).format('0.00')
          },
          editable: false
        },
        {
          headerName: this.$t('CargoMsg.Cargo_TaxRate'), colId: 'taxRate', field: 'taxRate', initialWidth: 180,
          headerClass: 'ag-header-cell-right',
          cellStyle: {
            textAlign: 'right'
          },
          valueFormatter: (params) => {
            return this.$numeral(params.value).format('0.00')
          },
          editable: false
        },
        {
          headerName: this.$t('CargoMsg.Cargo_TaxAmount'), colId: 'taxAmount', field: 'taxAmount', initialWidth: 180,
          headerClass: 'ag-header-cell-right',
          cellStyle: {
            textAlign: 'right'
          },
          valueFormatter: (params) => {
            return this.$numeral(params.value).format('0.00')
          }
        }
        /*, {
          headerName: this.$t('CargoMsg.Cargo_estimationAmount'), colId: 'estimationAmount', field: 'estimationAmount', initialWidth: 180,
          headerClass: 'ag-header-cell-right',
          cellStyle: {
            textAlign: 'right'
          },
          valueFormatter: (params) => {
            return this.$numeral(params.value).format('0.00')
          },
          editable: false
        }*/
      ],
      gridApi: null,
      rowData: []
    }
  },
  watch: {
    visible(newVal) {
      this.innerVisible = newVal
    },
    innerVisible(newVal) {
      this.$emit('update:visible', newVal)
    }
  },
  created() {
    if (this.visible) {
      this.innerVisible = true
    }
  },
  methods: {
    showDetail(data) {
      queryRelevanceChargeFunc({ uuid: data.uuid }).then(res => {
        this.rowData = res.data
      })
    },
    cancel(flag = false) {
      this.$emit('close', flag)
    }
  }
}
</script>
<style scoped>

</style>

